<template>
    <div class="footer">
      <div class="s-header">
        <div class="left">友情链接</div>
      </div>
      <ul class="friendlink clearfix">
          <li><a rel="nofollow" href="http://www.people.com.cn/" target="_blank">人民网</a></li>
          <li><a rel="nofollow" href="http://www.xinhuanet.com/" target="_blank">新华网</a></li>
          <li><a rel="nofollow" href="http://www.cctv.com/" target="_blank">央视网</a></li>
          <li><a rel="nofollow" href="http://www.sina.com.cn/" target="_blank">新浪</a></li>
          <li><a rel="nofollow" href="http://www.sohu.com/" target="_blank">搜狐</a></li>
          <li><a rel="nofollow" href="http://www.163.com/" target="_blank">网易</a></li>
          <li><a rel="nofollow" href="http://www.cnr.cn/" target="_blank">中国广播网</a></li>
          <li><a rel="nofollow" href="http://www.chinanews.com/" target="_blank">中国新闻网</a></li>
          <li><a rel="nofollow" href="http://www.ce.cn/" target="_blank">中国经济网</a></li>
          <li><a rel="nofollow" href="http://www.youth.cn/" target="_blank">中国青年网</a></li>
          <li><a rel="nofollow" href="http://www.newcic.com.cn/" target="_blank">诚信在线</a></li>
          <li><a rel="nofollow" href="http://cn.chinadaily.com.cn/" target="_blank">中国日报网</a></li>
          <li><a rel="nofollow" href="http://www.gmw.cn/" target="_blank">光明网</a></li>
          <li><a rel="nofollow" href="http://www.minsheng360.com/" target="_blank">民生360</a></li>
          <li><a rel="nofollow" href="http://www.msw58.com/" target="_blank">民生之窗</a></li>
          <li><a rel="nofollow" href="http://www.mx8.com/" target="_blank">民生信息网</a></li>
          <li><a rel="nofollow" href="http://www.qianxinews.cn/" target="_blank">浅析新闻</a></li>
          <li><a rel="nofollow" href="http://zu.qd.fang.com/" target="_blank">房天下</a></li>
          <li><a rel="nofollow" href="http://www.029home.cn/" target="_blank">西安新闻</a></li>
          <li><a rel="nofollow" href="http://www.bbaqw.com/" target="_blank">安全网</a></li>
          <li><a rel="nofollow" href="http://www.budui.com/" target="_blank">部队网</a></li>
          <li><a rel="nofollow" href="http://www.centrechina.com/" target="_blank">焦点中国网</a></li>
          <li><a rel="nofollow" href="http://www.59net.net/" target="_blank">民声网</a></li>
          <li><a rel="nofollow" href="http://www.famouspr.com/" target="_blank">启创天下</a></li>
          <li><a rel="nofollow" href="http://www.bookshi.com/" target="_blank">互联网金融</a></li>
          <li><a rel="nofollow" href="http://www.cri.cn/" target="_blank">国际在线</a></li>
          <li><a rel="nofollow" href="http://www.onlinejl.com/" target="_blank">吉林在线</a></li>
        </ul>
    </div>
</template>

<script>
export default {
  name: ''
}
</script>

<style lang='less' scoped>
  .s-header {
    width: 100%;
    height: 24px;
    line-height: 24px;
    border-left: 4px solid #dc2d4b;
    margin-bottom: 20px;
    .left {
      display: inline-block;
      width: 100px;
      font-size: 24px;
      height: 24px;
      font-weight: bold;
      padding-left: 30px;
    }
  }
.footer {
  width: 980px;
  margin: 0 auto;
  height: 200px;
  margin-top: 20px;
  font-size: 14px;
  line-height: 24px;
  ul {
    margin: 20px auto;
    li {
      display: inline-block;
      a {
        color: #222;
        margin-right: 20px;
      }
    }
  }
}
</style>
